import React, { useEffect, useContext, useRef } from 'react';
import { AppContext } from '../../../context/Context';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Button } from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
} from '@mui/icons-material/';
import { useNavigate } from 'react-router-dom';

function ModalConfirmationLogout() {
  const { t } = useTranslation();

  const { updateShowModalConfirmLogout, logoutKiosk, logoutUser, hall } =
    useContext(AppContext);
  const navigate = useNavigate();

  const hallRef = useRef(hall);
  useEffect(() => {
    hallRef.current = hall;
  }, [hall]);

  const handleCancel = () => {
    updateShowModalConfirmLogout(false);
  };

  const handleConfirm = () => {
    updateShowModalConfirmLogout(false);
    logoutUser();
    logoutKiosk();
    const hallToUse = hallRef.current || hall || 'Roulingo';
    navigate(`/login-kiosk?hall=${encodeURIComponent(hallToUse)}`, {
      replace: true,
    });
  };

  return (
    <>
      <div id="react-confirm-alert">
        <div
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 9999,
            background: 'rgba(3,6,18,0.88)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px 16px',
          }}
        >
          <div
            style={{
              width: 'min(760px, 96vw)',
              borderRadius: '24px',
              overflow: 'hidden',
              border: '1px solid rgba(255,255,255,0.12)',
              boxShadow: '0 30px 90px rgba(0,0,0,0.65)',
              backdropFilter: 'blur(14px)',
              WebkitBackdropFilter: 'blur(14px)',
              background:
                'linear-gradient(135deg, rgba(18,26,55,0.98), rgba(10,14,28,0.98))',
              padding: '40px 48px',
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
            }}
          >
            <Typography sx={{ color: 'white', fontSize: '28px', fontWeight: 900 }}>
              {t('kiosk.confirmLogoutTitle')}
            </Typography>
            <Typography sx={{ color: 'rgba(255,255,255,0.75)', fontSize: '18px' }}>
              {t('kiosk.confirmLogoutMessage')}
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
              <Button
                variant="contained"
                startIcon={<CheckCircleIcon />}
                onClick={handleConfirm}
                sx={{
                  bgcolor: '#FFC727',
                  color: '#000',
                  fontWeight: 800,
                  fontSize: '18px',
                  height: '72px',
                  px: 4,
                  boxShadow: '0 4px 18px rgba(255,199,39,0.35)',
                  '&:hover': {
                    bgcolor: '#e6b320',
                    boxShadow: '0 6px 22px rgba(255,199,39,0.5)',
                  },
                }}
              >
                {t('sales.confirm')}
              </Button>
              <Button
                variant="contained"
                startIcon={<CancelIcon />}
                onClick={handleCancel}
                sx={{
                  bgcolor: 'rgba(255,255,255,0.08)',
                  color: 'rgba(255,255,255,0.75)',
                  border: '1px solid rgba(255,255,255,0.14)',
                  fontWeight: 700,
                  fontSize: '18px',
                  height: '72px',
                  px: 4,
                  '&:hover': { bgcolor: 'rgba(255,255,255,0.14)' },
                }}
              >
                {t('sales.cancel')}
              </Button>
            </Box>
          </div>
        </div>
      </div>
    </>
  );
}

export default ModalConfirmationLogout;
